import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';

import { CommonModule } from '@angular/common';

import { MatTableDataSource, MatTableModule } from '@angular/material/table';

import { MatButtonModule } from '@angular/material/button';

import { MatIconModule } from '@angular/material/icon';

import { MatSort, MatSortModule } from '@angular/material/sort';

import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';

import { RouterModule } from '@angular/router';


import { AdminService } from '../../services/admin';

import { PermissionService } from '../../../../core/authorization/permission';

import { Liquidation } from '../../../../shared/models/liquidation';

import { Observable, of } from 'rxjs';

import { Excel } from '../../../../shared/utils/excel';

import { AlertService } from '../../../../core/ui/alert';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SummaryDialog, SummaryDialogResult } from './summary-dialog/summary-dialog';
import { LiquidationForm } from '../liquidation-form/liquidation-form';



@Component({
	selector: 'app-liquidations',
	standalone: true,
	imports: [CommonModule,

    MatTableModule,

    MatButtonModule,

    MatIconModule,

    MatSortModule,

    MatPaginatorModule,

	MatFormFieldModule,

    MatInputModule,

    FormsModule,
    MatDialogModule,
    MatTooltipModule
,
    RouterModule
],
	templateUrl: './liquidations.html',
	styleUrl: './liquidations.css'
})

export class Liquidations implements OnInit, AfterViewInit {
	dataSource: MatTableDataSource<Liquidation> = new MatTableDataSource<Liquidation>([]);


  displayedColumns: string[] = [

    'week',

    'year',

    'startDate',

    'endDate',

    'status',

    'createdBy',

    'createdAt',

    'actions'

  ];


  canCreateLiquidation$: Observable<boolean>;

  canEditLiquidation$: Observable<boolean>;

  canDeleteLiquidation$: Observable<boolean>;

  canViewSummary$: Observable<boolean>;
  canSendNotifications$: Observable<boolean>;

  // TEMPORAL: eliminar antes de producción
  canFixLiquidationDateRangesTemp$: Observable<boolean>;


  @ViewChild(MatSort) sort!: MatSort;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  private statusTranslations: { [key: string]: string } = {

    'DRAFT': 'Borrador',

    'UPLOADING': 'Subiendo Archivo',

    'PROCESSING_EXCEL': 'Procesando Excel',

    'COMPLETED': 'Completada',

    'NOTIFICATIONS_SENT': 'Notificaciones enviadas',

    'PROCESSED_EXCEL': 'Excel procesado',

    'FAILED_INVALID_UPLOAD_PATH': 'Falló: Ruta de Carga Inválida',

    'FAILED_EMPTY_FILE': 'Falló: Archivo Vacío',

    'FAILED_INITIAL_STATUS_UPDATE': 'Falló: Actualización Inicial de Estado',

    'FAILED_INVALID_FILE_TYPE': 'Falló: Tipo de Archivo Inválido',

    'FAILED_NO_DATA': 'Falló: Sin Datos en Excel',

    'FAILED_FILE_CORRUPT': 'Falló: Archivo Corrupto',

    'FAILED_EXCEL_EMPTY_OR_NO_DATA': 'Falló: Excel Vacío o Sin Datos',

    'FAILED_NO_VALID_BUSES': 'Falló: Sin Buses Válidos',

    'FAILED_MASTER_DATA_FETCH': 'Falló: Error en Carga de Datos Maestros',

    'FAILED_EXCEL_FORMAT': 'Falló: Formato de Excel Inválido',

    'FAILED_PROCESSING_ERROR': 'Falló: Error de Procesamiento',

    'FAILED_TIMEOUT': 'Falló: Tiempo de Espera Excedido',

  };



  constructor(

    private adminService: AdminService,

    private permissionService: PermissionService,

    private excelService: Excel,

    private alertService: AlertService,
    private dialog: MatDialog

  ) {

    this.canCreateLiquidation$ = this.permissionService.hasPermission('liquidations.create');

    this.canEditLiquidation$ = this.permissionService.hasPermission('liquidations.update');

    this.canDeleteLiquidation$ = of(false);

    this.canViewSummary$ = this.permissionService.hasPermission('liquidations.read');
    this.canSendNotifications$ = this.permissionService.hasPermission('liquidations.read');
    this.canFixLiquidationDateRangesTemp$ = this.permissionService.hasPermission('*.*');

	this.dataSource.filterPredicate = (data: Liquidation, filter: string) => {
		const searchString = filter.trim().toLowerCase();
		const weekMatch                     = data.week.toString().toLowerCase().includes(searchString);
		const yearMatch                     = data.year.toString().toLowerCase().includes(searchString);
		

		return weekMatch || yearMatch;
	};
  }


  ngOnInit(): void {

    this.loadLiquidations();

  }


  ngAfterViewInit(): void {

    this.dataSource.sort = this.sort;

    this.dataSource.paginator = this.paginator;

  }

  getTranslatedStatus(liq: Liquidation): string {
    if(liq.notificationsStatus) {
      if(liq.notificationsStatus === 'SENT') {
        return 'Notificaciones enviadas';
      }
      if(liq.notificationsStatus === 'PARTIAL') {
        return 'Notificaciones parciales';
      }
      if(liq.notificationsStatus === 'FAILED') {
        return 'Notificaciones fallidas';
      }
    }

    return this.statusTranslations[liq.status] || liq.status;
  }
  

  async onCloneLastLiquidation(): Promise<void> {

    if (!confirm('¿Estás seguro de que deseas clonar la última liquidación? Se creará una nueva liquidación con la misma configuración básica y el estado Borrador.')) {

        return;

    }

    try {

        // USAR EL SERVICIO ADMINSERVICE PARA LA LLAMADA

        const newLiquidationId = await this.adminService.cloneLastLiquidation();


        if (newLiquidationId) {

            // El alert de éxito ya lo maneja adminService.

            // Solo falta refrescar el listado.

            this.loadLiquidations(); // Refrescar el listado para mostrar la nueva liquidación

        }

        // Los errores ya los maneja adminService

    } catch (error: any) {

        console.error('Error en el componente al clonar liquidación (ya debería haber sido manejado por AdminService):', error);

        // Opcional: podrías poner un alert genérico aquí si quieres un fallback,

        // pero AdminService ya debería mostrar un mensaje.

    }

}




  // TEMPORAL: eliminar después de ejecutarlo una sola vez
  async onFixLiquidationDateRangesTemp(): Promise<void> {
    if (!window.confirm('⚠️ ACCIÓN TEMPORAL DE CORRECCIÓN ⚠️\n\nEsto corregirá el rango de fechas (startDate/endDate) de las 30 liquidaciones de las semanas 1 a 30 del 2026, en el documento general y en el documento de cada socio.\n\n¿Estás seguro?')) {
      return;
    }

    const success = await this.adminService.fixLiquidationDateRangesTemp();

    if (success) {
      this.loadLiquidations();
    }
  }

  async loadLiquidations(): Promise<void> {

    const result = await this.adminService.getAllLiquidations();

    if (result) {

      this.dataSource.data = result;

    }

  }

 	applyFilter(event: Event): void {
		const filterValue = (event.target as HTMLInputElement).value;
		this.dataSource.filter = filterValue.trim().toLowerCase();

		if(this.dataSource.paginator) {
			this.dataSource.paginator.firstPage();
		}
	}


  onCreateLiquidation(): void {
    const dialogRef = this.dialog.open(LiquidationForm, { width: '700px', disableClose: true, data: {} });
    dialogRef.afterClosed().subscribe(result => { if (result) this.loadLiquidations(); });
  }

  onEditLiquidation(liq: Liquidation): void {
    const dialogRef = this.dialog.open(LiquidationForm, { width: '700px', disableClose: true, data: { liquidation: liq } });
    dialogRef.afterClosed().subscribe(result => { if (result) this.loadLiquidations(); });
  }

  async onFinalizeLiquidation(id: string): Promise<void> {
    if (!window.confirm('¿Confirmas que los datos están correctos y deseas finalizar esta liquidación?')) return;
    const success = await this.adminService.updateLiquidation(id, { status: 'COMPLETED' });
    if (success) this.loadLiquidations();
  }


  async onDeleteLiquidation(id: string): Promise<void> {

    if (window.confirm('¿Estás seguro de que quieres eliminar esta liquidación? Esta acción es irreversible.')) {

      const success = await this.adminService.deleteLiquidation(id);

      if (success) {

        this.loadLiquidations();

      }

    }

  }


  onViewSummary(liq: Liquidation): void {
    const dialogRef = this.dialog.open(SummaryDialog, {
      width: '420px',
      disableClose: true,
      data: { liquidation: { id: liq.id, week: liq.week, year: liq.year } }
    });

    dialogRef.afterClosed().subscribe((result: SummaryDialogResult | undefined) => {
      if (!result) return;
      this.generateSummaryExcel(liq, result.grouping, result.reportType, dialogRef);
    });
  }

  private async generateSummaryExcel(
    liq: Liquidation,
    grouping: 'partner' | 'entity' | 'route' | 'bus' | 'partner_entity_route',
    reportType: 'integrated' | 'bank_file' | 'invoice_reconciliation' | 'liquidation_by_route',
    dialogRef?: MatDialogRef<SummaryDialog, any>
  ): Promise<void> {
    const summaryData = await this.adminService.generateLiquidationSummaryExcel(liq.id, grouping, reportType);

    if(!summaryData || summaryData.length === 0) {
      this.alertService.error('No se obtuvo información para generar el resumen.', 'Error');
      return;
    }

    let processedSummaryLines = summaryData;
    let displayHeaders: string[] = [];
    let dataKeys: string[] = [];
    const reportLabel = reportType === 'bank_file'
      ? 'Archivo para Bancos'
      : reportType === 'invoice_reconciliation'
        ? 'Cuadre de facturas'
        : reportType === 'liquidation_by_route'
          ? 'Liquidación por ruta'
          : 'Resumen de Liquidacion';

    if(reportType === 'bank_file') {
      displayHeaders = ['Número de cuenta', 'Cliente', 'Monto a pagar (Q)', 'Correo'];
      dataKeys = ['accountNumber', 'partnerName', 'amountToDeposit', 'partnerEmail'];
    } else if(reportType === 'invoice_reconciliation') {
      displayHeaders = ['Número de cuenta', 'Cliente', 'Factura (Q)', 'Monto a pagar (Q)', 'Correo', 'Ruta'];
      dataKeys = ['accountNumber', 'partnerName', 'totalPassages', 'amountToDeposit', 'partnerEmail', 'routeName'];
    } else if(reportType === 'liquidation_by_route') {
      const discountNames = new Set<string>();

      summaryData.forEach((line: any) => {
        (line.appliedDiscounts || []).forEach((discount: any) => {
          if(discount && discount.name) {
            discountNames.add(discount.name);
          }
        });
      });

      const dynamicDiscountNames = Array.from(discountNames).sort();

      processedSummaryLines = summaryData.map((line: any) => {
        const newLine: any = {
          nit: line.nit,
          partnerName: line.partnerName,
          companyName: line.entityName,
          busCount: Array.isArray(line.buses)
            ? line.buses.length
            : (line.buses ? String(line.buses).trim().split(/\s+/).filter(Boolean).length : 0),
          totalPassages: line.totalPassages,
          totalDiscounts: line.totalDiscounts,
          amountToDeposit: line.amountToDeposit
        };

        dynamicDiscountNames.forEach(discountName => {
          const discount = (line.appliedDiscounts || []).find((d: any) => d.name === discountName);
          newLine[`discount_${this.cleanColumnName(discountName)}`] = discount ? discount.amount : 0;
        });

        return newLine;
      });

      displayHeaders = [
        'NIT',
        'Cliente',
        'Empresa',
        'Cantidad de Buses',
        'Total de pasajes',
        ...dynamicDiscountNames.map(name => `Desc. ${name} (Q)`),
        'Total descuentos',
        'Depositar'
      ];
      dataKeys = [
        'nit',
        'partnerName',
        'companyName',
        'busCount',
        'totalPassages',
        ...dynamicDiscountNames.map(name => `discount_${this.cleanColumnName(name)}`),
        'totalDiscounts',
        'amountToDeposit'
      ];
    } else {
      const integratedDiscountOrderIds = [
        'xi66kFNk1nkBuaPyHfQR',
        'Y0ab650Qt9DSOTLGtb76',
        'GocArxmjwcVLDJ1Hc5ZD',
        'VdA3Ag7EN6jKkoo2lIfE',
        'KVoVwNdAIUlnubVAnzyA',
        'm0QikPAKMckUa4vb5lEK',
        'i3351cL6SrcoyRXdPJ4C'
      ];

      const orderedSourceIds = [
        ...integratedDiscountOrderIds.slice(0, 3),
        'ISR_GLOBAL',
        'RETENTION_IVA',
        ...integratedDiscountOrderIds.slice(3)
      ];

      const sourceIdToDiscount = new Map<string, { sourceId: string; name: string }>();

      summaryData.forEach((line: any) => {
        (line.appliedDiscounts || []).forEach((discount: any) => {
          const sourceId = String(discount?.sourceId || '').trim();
          const name = String(discount?.name || '').trim();
          if(!sourceId || !name) {
            return;
          }
          if(!sourceIdToDiscount.has(sourceId)) {
            sourceIdToDiscount.set(sourceId, { sourceId, name });
          }
        });
      });

      const knownSourceIds = new Set(orderedSourceIds);

      const orderedKnownDiscounts = orderedSourceIds
        .filter(sourceId => sourceIdToDiscount.has(sourceId))
        .map(sourceId => sourceIdToDiscount.get(sourceId)!);

      const unknownDiscounts = Array.from(sourceIdToDiscount.values())
        .filter(discount => !knownSourceIds.has(discount.sourceId))
        .sort((a, b) => a.name.localeCompare(b.name));

      const finalDiscountColumns = [...orderedKnownDiscounts, ...unknownDiscounts].map(discount => ({
        sourceId: discount.sourceId,
        header: discount.sourceId === 'ISR_GLOBAL' ? 'Retención ISR' : discount.name,
        key: `discount_${this.cleanColumnName(discount.sourceId)}`
      }));

      processedSummaryLines = summaryData.map((line: any) => {
        const discountAmountBySource = new Map<string, number>();
        (line.appliedDiscounts || []).forEach((discount: any) => {
          const sourceId = String(discount?.sourceId || '').trim();
          if(!sourceId) {
            return;
          }
          discountAmountBySource.set(sourceId, Number(discount?.amount) || 0);
        });

        const newLine: any = {
          nit: line.nit || '',
          partnerName: line.partnerName || '',
          partnerEmail: line.partnerEmail || '',
          week: liq.week || '',
          year: liq.year || '',
          daysOfWeek: liq.daysOfWeek || '',
          entityName: line.entityName || '',
          routeName: line.routeName || '',
          fromDate: this.formatDateToDDMMYYYY(liq.startDate),
          toDate: this.formatDateToDDMMYYYY(liq.endDate),
          buses: line.buses || '',
          totalPassages: Number(line.totalPassages) || 0,
          totalDiscounts: Number(line.totalDiscounts) || 0,
          amountToDeposit: Number(line.amountToDeposit) || 0
        };

        finalDiscountColumns.forEach(column => {
          newLine[column.key] = discountAmountBySource.get(column.sourceId) || 0;
        });

        return newLine;
      });

      displayHeaders = [
        'NIT CLIENTES',
        'NOMBRES Y APELLIDOS DEL CLIENTE',
        'CORREO DEL CLIENTE',
        'SEMANA',
        'AÑO',
        'DIAS DE LA SEMANA',
        'ENTIDAD',
        'RUTA',
        'DEL',
        'AL',
        'AUTOBUSES',
        'FACTURACIÓN PASAJES',
        ...finalDiscountColumns.map(column => column.header),
        'TOTAL DE DESCUENTOS',
        'DEPOSITAR'
      ];

      dataKeys = [
        'nit',
        'partnerName',
        'partnerEmail',
        'week',
        'year',
        'daysOfWeek',
        'entityName',
        'routeName',
        'fromDate',
        'toDate',
        'buses',
        'totalPassages',
        ...finalDiscountColumns.map(column => column.key),
        'totalDiscounts',
        'amountToDeposit'
      ];
    }

    const reportTypeLabel = reportType === 'bank_file'
      ? 'bancos'
      : reportType === 'invoice_reconciliation'
        ? 'cuadre_facturas'
        : reportType === 'liquidation_by_route'
          ? 'liquidacion_por_ruta'
          : 'integrado';
    const fileName = `Liquidacion_${liq.year}_Semana_${liq.week}_${liq.id.substring(0, 5)}_${reportTypeLabel}_agrupado_${grouping}`;

    const detailsData: any[][] = [
      [reportLabel],
      ['ID:', liq.id || 'N/A'],
      ['Semana:', liq.week || 'N/A'],
      ['Año:', liq.year || 'N/A'],
      ['Agrupación:', grouping],
      ['Días de descuento:', liq.daysOfWeek || 'N/A'],
      ['Estado:', liq.status || 'N/A']
    ];

    const dynamicDiscountTotalsKeys = dataKeys.reduce((acc: Record<string, 'sum'>, key) => {
      if(key.startsWith('discount_')) {
        acc[key] = 'sum';
      }
      return acc;
    }, {});

    const summaryCurrencyKeys = dataKeys.filter((key) =>
      key === 'totalPassages'
      || key === 'totalDiscounts'
      || key === 'amountToDeposit'
      || key.startsWith('discount_')
    );

    const summaryExportOptions = reportType === 'liquidation_by_route'
      ? {
          appendTotalsRow: true,
          totalsKeys: {
            busCount: 'sum' as const,
            totalPassages: 'sum' as const,
            totalDiscounts: 'sum' as const,
            amountToDeposit: 'sum' as const,
            ...dynamicDiscountTotalsKeys
          },
          negativeRedKeys: summaryCurrencyKeys,
          currencyKeys: summaryCurrencyKeys,
          centerHeaders: true,
          headerFillColor: '93C47D',
          headerFontColor: '000000',
          headerRowHeight: 24
        }
      : reportType === 'invoice_reconciliation'
        ? {
            negativeRedKeys: summaryCurrencyKeys,
            currencyKeys: summaryCurrencyKeys,
            centerHeaders: true,
            headerFillColor: '93C47D',
            headerFontColor: '000000',
            headerRowHeight: 24
          }
        : {
            negativeRedKeys: summaryCurrencyKeys,
            currencyKeys: summaryCurrencyKeys,
            centerHeaders: true,
            headerFillColor: '93C47D',
            headerFontColor: '000000',
            headerRowHeight: 24
          };

    this.excelService.exportDataToExcel(
      processedSummaryLines,
      displayHeaders,
      dataKeys,
      fileName,
      reportLabel,
      detailsData,
      'Detalles de Liquidacion',
      summaryExportOptions
    );

    this.alertService.success('Excel generado con éxito.', 'Éxito');

    if(dialogRef) {
      dialogRef.close();
    }
  }


  onSendNotifications(liq: Liquidation): void {
    const confirmed = window.confirm('¿Confirmas el envío de notificaciones para esta liquidación?');

    if(!confirmed) {
      return;
    }

    this.adminService.sendLiquidationNotifications(liq.id).then(success => {
      if(success) {
        this.loadLiquidations();
      }
    });
  }

  async generateNotificationsReport(liq: Liquidation): Promise<void> {
    const reportData = await this.adminService.generateNotificationsReportExcel(liq.id);

    if(!reportData || reportData.length === 0) {
      this.alertService.error('No se obtuvo información para generar el reporte.', 'Error');
      return;
    }

    const discountNames = new Set<string>();

    reportData.forEach((line: any) => {
      (line.discounts || []).forEach((discount: any) => {
        if(discount && discount.name) {
          discountNames.add(discount.name);
        }
      });
    });

    const dynamicDiscountNames = Array.from(discountNames).sort();

    const processedLines = reportData.map((line: any) => {
      const totalDiscounts = (line.discounts || []).reduce((sum: number, d: any) => sum + (Number(d.amount) || 0), 0);
      const isrAmount = Number(line.isrAmount) || 0;
      const retentionAmount = Number(line.retentionIVAAmount) || 0;
      const totalPassages = Number(line.totalPassages) || 0;
      const totalToPay = Number((totalPassages - totalDiscounts - isrAmount - retentionAmount).toFixed(2));

      const newLine: any = {
        partnerName: line.partnerName || '',
        partnerEmail: line.partnerEmail || '',
        billingMode: line.billingMode === 'WEEKLY' ? 'Semanal' : line.billingMode === 'DAILY' ? 'Diario' : (line.billingMode || ''),
        group: line.group || line.bus || '',
        date: line.date || '',
        totalPassages: totalPassages,
        isrAmount: isrAmount,
        retentionIVAAmount: retentionAmount,
        totalToPay: totalToPay
      };

      dynamicDiscountNames.forEach(discountName => {
        const discount = (line.discounts || []).find((d: any) => d.name === discountName);
        newLine[`discount_${this.cleanColumnName(discountName)}`] = discount ? discount.amount : 0;
      });

      return newLine;
    });

    const displayHeaders = [
      'Cliente',
      'Email cliente',
      'Modo facturación',
      'Grupo',
      'Fecha',
      'Total pasajes',
      ...dynamicDiscountNames.map(name => `Desc. ${name} (Q)`),
      'ISR (Q)',
      'Retención IVA (Q)',
      'Total a pagar (Q)'
    ];

    const dataKeys = [
      'partnerName',
      'partnerEmail',
      'billingMode',
      'group',
      'date',
      'totalPassages',
      ...dynamicDiscountNames.map(name => `discount_${this.cleanColumnName(name)}`),
      'isrAmount',
      'retentionIVAAmount',
      'totalToPay'
    ];

    const reportLabel = 'Reporte de Notificaciones';
    const fileName = `Notificaciones_${liq.year}_Semana_${liq.week}_${liq.id.substring(0, 5)}`;

    const detailsData: any[][] = [
      [reportLabel],
      ['ID:', liq.id || 'N/A'],
      ['Semana:', liq.week || 'N/A'],
      ['Año:', liq.year || 'N/A'],
      ['Estado:', this.getTranslatedStatus(liq)]
    ];

    this.excelService.exportDataToExcel(
      processedLines,
      displayHeaders,
      dataKeys,
      fileName,
      reportLabel,
      detailsData,
      'Detalles de Notificaciones',
      {
        centerHeaders: true,
        headerFillColor: '93C47D',
        headerFontColor: '000000',
        headerRowHeight: 24,
        negativeRedKeys: [
          'totalPassages',
          ...dynamicDiscountNames.map(name => `discount_${this.cleanColumnName(name)}`),
          'isrAmount',
          'retentionIVAAmount',
          'totalToPay'
        ],
        currencyKeys: [
          'totalPassages',
          ...dynamicDiscountNames.map(name => `discount_${this.cleanColumnName(name)}`),
          'isrAmount',
          'retentionIVAAmount',
          'totalToPay'
        ]
      }
    );

    this.alertService.success('Excel generado con éxito.', 'Éxito');
  }


  /**

   * Normaliza fechas a formato dd/mm/yyyy para reportes.

   */

  private formatDateToDDMMYYYY(value: any): string {
    if(!value) {
      return '';
    }

    let parsedDate: Date | null = null;

    if(value instanceof Date) {
      parsedDate = value;
    } else if(typeof value?.toDate === 'function') {
      const maybeDate = value.toDate();
      if(maybeDate instanceof Date) {
        parsedDate = maybeDate;
      }
    } else if(typeof value?.seconds === 'number') {
      parsedDate = new Date(value.seconds * 1000);
    } else if(typeof value?._seconds === 'number') {
      parsedDate = new Date(value._seconds * 1000);
    } else if(typeof value === 'number') {
      parsedDate = new Date(value);
    } else if(typeof value === 'string') {
      const trimmedValue = value.trim();
      if(!trimmedValue) {
        return '';
      }

      const ddmmyyyyMatch = trimmedValue.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if(ddmmyyyyMatch) {
        const day = Number(ddmmyyyyMatch[1]);
        const month = Number(ddmmyyyyMatch[2]);
        const year = Number(ddmmyyyyMatch[3]);
        const dateFromParts = new Date(year, month - 1, day);
        if(
          dateFromParts.getFullYear() === year
          && dateFromParts.getMonth() === month - 1
          && dateFromParts.getDate() === day
        ) {
          parsedDate = dateFromParts;
        }
      } else {
        const dateFromString = new Date(trimmedValue);
        if(!isNaN(dateFromString.getTime())) {
          parsedDate = dateFromString;
        }
      }
    }

    if(!parsedDate || isNaN(parsedDate.getTime())) {
      return '';
    }

    const day = String(parsedDate.getDate()).padStart(2, '0');
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const year = parsedDate.getFullYear();
    return `${day}/${month}/${year}`;
  }

  /**

   * Limpia el nombre del descuento para usarlo como clave de propiedad.

   * Ej: "Descuento Tecnológico" -> "DescuentoTecnologico"

   */

  private cleanColumnName(name: string): string {

    return name.replace(/[^a-zA-Z0-9]/g, ''); // Elimina caracteres no alfanuméricos

  }


}
